import {Box, HBox} from '@buncha/components/core/view';
import React, {useCallback} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import CrossIcon from '@buncha/components/core/icon/CrossIcon';
import {H1Text} from '@buncha/components/core/text';
import {Touchable} from '@buncha/components/core/touchable';
import {navigation} from '@buncha/config/navigation';
import {styles} from './styles';

interface BackScreenHeaderProps {
  title: string;
}

const BackScreenHeader: React.FC<BackScreenHeaderProps> = ({title}) => {
  const theme = useColorThemeType();
  const mortiseFont = useFontTheme('mortise');

  const goBack = useCallback(() => {
    if (navigation.canGoBack())
      // Use React Navigation stack if available
      navigation.goBack();
    else if (window.history.length > 1)
      // Fallback to browser's native back behavior
      window.history.back();
  }, []);

  return (
    <Box
      style={[
        styles.container,
        {backgroundColor: theme?.background.blue[500]},
      ]}>
      <HBox>
        <H1Text
          style={{
            color: theme?.text.white[100],
            fontFamily: mortiseFont[700].normal,
          }}>
          {title}
        </H1Text>
        <Touchable
          onPress={goBack}
          style={{backgroundColor: theme?.background.blue[500]}}>
          <CrossIcon
            stroke={theme?.background.white[100]}
            width={24}
            height={24}
            viewBox="0 0 20 20"
          />
        </Touchable>
      </HBox>
    </Box>
  );
};

export default React.memo(BackScreenHeader);
